<template>
  <section class="dc_container">
    <header class="banner">
      <article class="title">{{ $t('开放能力') }}</article>
      <article class="open_api">{{ $t('Open API能够为合作伙伴提供丰富的应用开发和系统集成能力') }}</article>
      <a-button type="primary" class="button" @click="connect">
        {{ $t('联系我们') }}
        <img :src="arrow" class="icon" :preview="false" alt="free trial" />
      </a-button>
    </header>
    <section class="content">
      <section class="item" v-for="{ img, title, content } in list" :key="title">
        <img :src="img" :alt="title" class="icon" />
        <article>
          <article class="title">{{ $t(title) }}</article>
          <article class="desc">{{ $t(content) }}</article>
        </article>
      </section>
    </section>
  </section>
</template>

<script setup lang="ts">
import arrow from '@/assets/icons/arrow.svg';
const list = [
  {
    img: 'https://video.reta-inc.com/image/default/0BAE679099A946A2AE42A5C0EFE7806E-6-2.png',
    title: '让企业内部系统变成全球人力资源平台',
    content: '您不需要额外开发复杂功能，仅需调用几个API完成全球人力资源管理',
  },
  {
    img: 'https://video.reta-inc.com/image/default/C6D8F36CD78D4575A48D14FE2B6EF47C-6-2.png',
    title: '将DG.hire能力集成到任何工具中',
    content: '它可以轻松集成到您的内部工具中，例如薪酬工资单等，创建符合您业务需求的自定义工作流',
  },
  {
    img: 'https://video.reta-inc.com/image/default/1447353EEE6647598FC4FA979B79B106-6-2.png',
    title: '第三方开发人员可以构建全新的产品',
    content:
      'DG.hire能够提供国家维度的多个工具API，例如雇佣指南、雇佣成本计算器、员工工资计算器、全球薪酬洞察等，满足第三方平台业务需求',
  },
];
function connect() {
  useLeadsInfo('关于我们-开放能力-联系我们', 'contactUs');
}
useSeoHead();
</script>

<style lang="less" scoped>
@media screen and(min-width:800px) {
  .dc_container {
    min-width: 1344px;
    .banner {
      padding: 86px 0 48px;
      background-image: url('https://video.reta-inc.com/image/default/1B5CDE569CA740C68AA9A468912505F7-6-2.png');
      background-repeat: no-repeat;
      background-size: auto 100%;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        text-align: center;
        font-weight: 600;
        font-size: 52px;
        line-height: 73px;
      }
      .open_api {
        text-align: center;
        margin-top: 24px;
        font-size: 24px;
        line-height: 34px;
      }
      .button {
        font-weight: 600;
        font-size: 26px;
        line-height: 28px;
        letter-spacing: 0.02em;
        padding: 0 24px;
        height: 64px;
        border-radius: 8px;
        margin-top: 48px;
      }
    }
    .content {
      padding: 48px 0;
      background: #f5f8ff;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 24px;
      .item {
        box-sizing: border-box;
        width: 1280px;
        background: #ffffff;
        border-radius: 12px;
        display: flex;
        gap: 24px;
        padding: 32px;
        .icon {
          width: 100px;
          height: 100px;
        }
        .title {
          margin-top: 12px;
          font-weight: 500;
          font-size: 24px;
          line-height: 34px;
          color: #1d2129;
        }
        .desc {
          margin-top: 12px;
          font-size: 18px;
          line-height: 32px;
          color: #4e5969;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
@media screen and(max-width:800px) {
  .dc_container {
    .banner {
      padding: 32px 0 23px;
      background-image: url('https://video.reta-inc.com/image/default/88CE13D33662408FB48261EBC241F6DC-6-2.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        text-align: center;
        font-weight: 600;
        font-size: 28px;
        line-height: 39px;
      }
      .open_api {
        padding: 0 20px;
        margin-top: 8px;
        text-align: center;
        line-height: 20px;
      }
      .button {
        font-size: 16px;
        line-height: 28px;
        letter-spacing: 0.02em;
        padding: 0 24px;
        height: 42px;
        border-radius: 8px;
        margin-top: 16px;
        color: #ffffff;
        display: flex;
        align-items: center;
        .icon {
          width: 24px;
          height: 24px;
        }
      }
    }
    .content {
      padding: 48px 16px;
      background: #f5f8ff;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 24px;
      .item {
        // box-sizing: border-box;
        // width: 1280px;
        background: #ffffff;
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;
        // gap: 24px;
        padding: 14px 12px 20px;
        .icon {
          width: 60px;
          height: 60px;
        }
        .title {
          margin-top: 16px;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
          text-align: center;

          /* 颜色/灰度-1 */

          color: #1d2129;
        }
        .desc {
          margin-top: 6px;
          line-height: 22px;
          color: #4e5969;
          text-align: center;
        }
      }
    }
  }
}
</style>
